











































































































































































import { User } from "@/store/user/types";
import { Component, Vue } from "vue-property-decorator";
import SecretKeyModal from './secret-key-modal/SecretKeyModal.vue';
import * as userService from '@/services/user/index';
import ConfirmationModal from '@/components/confirmationModal/ConfirmationModal.vue'
import Loading from "@/components/loading/Loading.vue";

@Component({
  name: "UserForm",
  components: {
    SecretKeyModal,
    ConfirmationModal,
    Loading,
  }
})
export default class UserForm extends Vue {
  private secretKey: string | null = null;
  private isConfirmationOpen = false;
  private isLoading = false;

  get me(): User {
    return this.$store.state.user;
  }

  private clearSecretKey() {
    this.secretKey = null;
    this.isConfirmationOpen = false;
  }

  private openConfirmation() {
    this.isConfirmationOpen = true;
  }

  private async generateSecretKey() {
    this.isLoading = true;
    try {
      this.secretKey = await userService.generateSecretKey(this.me.companyId);
    } catch {
      this.secretKey = null;
    } finally {
      this.$nextTick(() => {
        this.isLoading = false;
      });
    }
  }

  private async cancelSecretKey() {
    this.isConfirmationOpen = false;
  }
  
}
